<template>
    <div class="success">
        <div class="success__inner">
            <div class="success__top">
                <div class="success__pic">
                    <img src="@/assets/images/check-in/success.svg" alt="">
                </div>
                <h4 class="success__title title-h4">
                    {{$t('studio.check-in.success.title')}}
                </h4>
                <p class="success__sub font-medium">
                    {{$t('studio.check-in.success.subtitle')}}
                </p>
                <p class="success__sub font-reg">
                    {{$t('studio.check-in.success.transaction')}} <b class="font-semi">{{transaction}}</b>
                </p>
            </div>
            <div class="success__action">
                    <button
                            type="button"
                            class="btn btn-m btn-gradient"
                            @click="goToMain"
                    >
                        <span>
                            {{$t('button.back-to-dashboard')}}
                        </span>
                    </button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            transaction: {
                required: true,
                type: Number
            }
        },
        methods: {
            goToMain() {
                this.$router.push('/studios/dashboard')
            }
        }
    }
</script>

<style lang="sass" scoped>
    .success
        text-align: center
        background: none!important
        border-color: transparent!important
        &__pic
            max-width: 96px
            max-height: 96px
            margin: 0 auto
            +xs
                max-width: 70px
                max-height: 70px
            img
                width: 100%
                height: 100%
        &__title
            margin: 24px 0 12px 0
            +xs
                margin: 12px 0
        &__sub
            font-size: 16px
            line-height: 24px
            letter-spacing: 0.5px
            +xs
                font-size: 14px
        &__action
            margin-top: 40px
            +xs
                margin-top: 32px
</style>